import Vue from 'vue';

const STORAGE_KEY = 'solar-energy-theme';

const readTheme = () => {
  try {
    return localStorage.getItem(STORAGE_KEY) === 'light' ? 'light' : 'dark';
  } catch (error) {
    return 'dark';
  }
};

export const themeState = Vue.observable({ current: readTheme() });

const applyTheme = () => {
  document.documentElement.setAttribute('data-theme', themeState.current);
};

export const toggleTheme = () => {
  themeState.current = themeState.current === 'dark' ? 'light' : 'dark';
  applyTheme();
  try {
    localStorage.setItem(STORAGE_KEY, themeState.current);
  } catch (error) {
    // 浏览器禁用本地存储时，仍允许在当前页面切换。
  }
};

applyTheme();

window.addEventListener('storage', event => {
  if (event.key === STORAGE_KEY || event.key === null) {
    themeState.current = readTheme();
    applyTheme();
  }
});
